import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { HLHero } from '../components/halo/HLHero';
import { HLHybrid } from '../components/halo/HLHybrid';
import { HLConcerns } from '../components/halo/HLConcerns';
import { HLCombineBBL } from '../components/halo/HLCombineBBL';
import { HLAddOns } from '../components/halo/HLAddOns';
import { HLTreatment } from '../components/halo/HLTreatment';
import { HLFAQ } from '../components/halo/HLFAQ';
import { HLWhyChoose } from '../components/halo/HLWhyChoose';
export function SkinResurfacingPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2620">
      <Navigation data-id="element-2621" />
      <main data-id="element-2622">
        <HLHero data-id="element-2623" />
        <HLHybrid data-id="element-2624" />
        <HLConcerns data-id="element-2625" />
        <HLCombineBBL data-id="element-2626" />
        <HLAddOns data-id="element-2627" />
        <HLTreatment data-id="element-2628" />
        <HLFAQ data-id="element-2629" />
        <HLWhyChoose data-id="element-2630" />
      </main>
      <Footer data-id="element-2631" />
    </div>;
}